import {
  IntegrationManagedAgentPage,
  IntegrationManagedAgentPageProps,
} from "~/pages/integrations/IntegrationManagedAgentPage";

const IntegrationManagedAgentEntryPage = ({
  scope,
}: IntegrationManagedAgentPageProps) => {
  return <IntegrationManagedAgentPage {...{ scope }} />;
};

export default IntegrationManagedAgentEntryPage;
